import {
  Box,
  Button,
  FormControl,
  Image,
  Input,
  VStack,
  Flex,
  Text,
} from "@chakra-ui/react";
import ForgetPassword from "@root/assets/images/forgotpassword.svg";
import {
  LinkText,
  AuthFormContainer,
  AuthCardEllipse,
  AuthCardTopFrame,
  AuthHeading,
  AuthSubheading,
  AuthFieldsWrapper,
  AuthButton,
  AuthButtonWrapper,
  AuthCheckboxText,
} from "@root/commonStyles/commonStyle";
import { LoginBrandingLogo } from "@root/components/branding";
import { ROUTE_NAMES } from "@root/constants";
import { updatePasswordRecoverEmail } from "@root/store/slices/entities";
import { resetPass } from "@root/store/thunks";
import { Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FloatingInput } from "../login/floating-input";
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { LanguageToggle } from "@root/components/dashboard/sidebar/languagetoggler";

export const ForgotPassword: React.FC = () => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const initialValues = {
    email: "",
  };
  const redirect_url = ROUTE_NAMES.RESET_PASSWORD;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSuccess = (email: string) => {
    setLoading(false);
    navigate(ROUTE_NAMES.CHECK_YOUR_EMAIL);
    dispatch(updatePasswordRecoverEmail(email));
  };
  const onSubmitHandler = (values: any) => {
    setLoading(true);
    dispatch(
      resetPass({
        payload: {
          email: values?.email,
          redirect_url,
        },
        onSuccess: () =>
          onSuccess({
            email: values?.email,
            redirect_url,
          } as any),
        onError: () => setLoading(false),
      })
    );
  };
  return (
    <Flex
      minH="100vh"
      width="100%"
      bg="#F5F5F5"
      align="center"
      justify="center"
    >
      <Box position="relative">
        <Box position="absolute" top="0" right="0" zIndex={1000}>
          <LanguageToggle variant="public" position="relative" />
        </Box>
        <AuthFormContainer minWidth={{ base: "auto", md: "550px" }}>
          <AuthCardEllipse />

          {/* Top Section */}
          <AuthCardTopFrame>
            <LoginBrandingLogo />

            <Flex direction="column" align="stretch" width="100%" gap="10px">
              <AuthHeading>{t("forgetPassword.forgetPassword")}</AuthHeading>
              <AuthSubheading>{t("forgetPassword.subHeading")}</AuthSubheading>
            </Flex>
          </AuthCardTopFrame>

          {/* Form */}
          <Formik initialValues={initialValues} onSubmit={onSubmitHandler}>
            {({ handleSubmit, errors, touched, values, setFieldValue }) => (
              <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                <AuthFieldsWrapper>
                  <Flex
                    direction="column"
                    align="flex-start"
                    gap="1rem"
                    width="100%"
                  >
                    {/* Email Input */}
                    <Flex direction="column" gap="0.5rem" width="100%">
                      <FloatingInput
                        id="email"
                        label={t("login.emailAddress")}
                        name="email"
                        type="email"
                        value={values.email}
                        error={errors.email}
                        touched={touched.email}
                        onChange={(e) => setFieldValue("email", e.target.value)}
                      />
                    </Flex>
                  </Flex>
                </AuthFieldsWrapper>

                {/* Button */}
                <AuthButtonWrapper>
                  <AuthButton
                    isLoading={loading}
                    isDisabled={!values.email}
                    bg={!values.email ? "#EBEBEB" : "black"}
                    color={!values.email ? "#BFBFBF" : "#FFFFFF"}
                    _hover={{
                      bg: !values.email ? "#dbd9d9ff" : "#3d3535ff",
                    }}
                    type="submit"
                  >
                    {t("forgetPassword.continue")}
                  </AuthButton>
                </AuthButtonWrapper>
              </form>
            )}
          </Formik>

          {/* Back to Login link */}
          <Flex
            justify="center"
            alignItems={"center"}
            gap="0.5rem"
            width="100%"
            cursor="pointer"
            onClick={() => navigate(ROUTE_NAMES.LOGIN)}
          >
            <ArrowBackIcon boxSize="16px" color="#2F2F34" />
            <AuthCheckboxText>{t("forgetPassword.backToLogin")}</AuthCheckboxText>
          </Flex>
        </AuthFormContainer>
      </Box>
    </Flex>
  );
};
